<template>
  <div class="typefamily mr-bt-table-bf">
    <div class="col-md-12 m-b no-padd">
      <div class="b-light">
        <div class="container">
          <ul class="m-t-md m-b-md h5 breadcrumb no-border bg-empty m-b-none m-l-n-sm">
            <li>
              <a href="#">การขาย</a>
            </li>
            <li class="active">
              <span class="text-success h4"> ใบคำขอใหม่ สำหรับครอบครัว</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="content-family clear" style="padding-top:5px;padding-bottom:40px;">
      <div class="col-md-6 col-sm-12 m-t">
        <div class="col-sm-12 family-bg-white">
          <div class="col-lg-5 col-md-3 col-xs-5">
            <img src="../assets/images/family/2-01.png" class="img-card-family img-full" />
          </div>
          <div class="col-lg-7 col-md-9 col-xs-7 no-padd">
            <div class="no-padd-b padd-h-f">
              <span class="head-fammily m-l-xs tx-card-family text-tvi">2 บุคคล</span>
              <span class="head-fammily tx-card-family tx-discount">ส่วนลดกลุ่ม 5%</span>
              <Button
                class="btn btn-s-xs pull-right"
                @click.native="createFamilyQuotation('FM001')"
              >
                ขอใบเสนอราคา
              </Button>
              <h6 class="m-l-xs m-t-xs">มีได้ทั้งหมด 3 กรณี</h6>
              <hr class="hr-1" />
            </div>
            <div class="col-md-12 col-xs-12 card-body-family">
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" />
                <i class="fas fa-user" />
                2 บิดา+มารดา
              </span>

              <hr class="hr-dot clear" />

              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" />
                1 บิดา/มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-child icon-color1" />
                1 เด็กโต
              </span>

              <hr class="hr-dot clear" />

              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" />
                1 บิดา/มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-baby icon-color2" />
                1 เด็กเล็ก
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-sm-12 m-t">
        <div class="col-sm-12 family-bg-white">
          <div class="col-lg-5 col-md-3 col-xs-5">
            <img src="@/assets/images/family/3-01.png" class="img-card-family img-full" />
          </div>
          <div class="col-lg-7 col-md-9 col-xs-7 no-padd">
            <div class="no-padd-b padd-h-f">
              <span class="head-fammily m-l-xs tx-card-family text-tvi">3 บุคคล</span>
              <span class="head-fammily tx-card-family tx-discount">ส่วนลดกลุ่ม 5%</span>
              <Button
                class="btn btn-s-xs pull-right"
                @click.native="createFamilyQuotation('FM002')"
              >
                ขอใบเสนอราคา
              </Button>
              <h6 class="m-l-xs m-t-xs">มีได้ทั้งหมด 1 กรณี</h6>
              <hr class="hr-1" />
            </div>
            <div class="col-md-12 col-xs-12 card-body-family">
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" />
                1 บิดา/มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-baby icon-color2" />
                <i class="fas fa-baby icon-color2" />
                2 เด็กเล็ก
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-sm-12 m-t">
        <div class="col-sm-12 family-bg-white">
          <div class="col-lg-5 col-md-3 col-xs-5">
            <img src="../assets/images/family/3-01.png" class="img-card-family img-full" />
          </div>
          <div class="col-lg-7 col-md-9 col-xs-7 no-padd">
            <div class="no-padd-b padd-h-f">
              <span class="head-fammily m-l-xs tx-card-family text-tvi">3 บุคคล</span>
              <span class="head-fammily tx-card-family tx-discount">ส่วนลดกลุ่ม 10%</span>
              <Button
                class="btn btn-s-xs pull-right"
                @click.native="createFamilyQuotation('FM003')"
              >
                ขอใบเสนอราคา
              </Button>
              <h6 class="m-l-xs m-t-xs">มีได้ทั้งหมด 4 กรณี</h6>
              <hr class="hr-1" />
            </div>
            <div class="col-md-12 col-xs-12 card-body-family">
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" />
                <i class="fas fa-user" /> 2 บิดา+มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user icon-color1" /> 1 เด็กโต
              </span>

              <hr class="hr-dot clear" />

              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" /> <i class="fas fa-user" /> 2 บิดา+มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-baby icon-color2" /> 1 เด็กเล็ก
              </span>

              <hr class="hr-dot clear" />

              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" /> 1 บิดา/มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" /> 2 เด็กโต
              </span>

              <hr class="hr-dot clear" />

              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" /> 1 บิดา/มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-child icon-color1" /> 1 เด็กโต
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-baby icon-color2" /> 1 เด็กเล็ก
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-sm-12 m-t">
        <div class="col-sm-12 family-bg-white">
          <div class="col-lg-5 col-md-3 col-xs-5">
            <img src="../assets/images/family/4-01.png" class="img-card-family img-full" />
          </div>
          <div class="col-lg-7 col-md-9 col-xs-7 no-padd">
            <div class="no-padd-b padd-h-f">
              <span class="head-fammily m-l-xs tx-card-family text-tvi">4 บุคคล</span>
              <span class="head-fammily tx-card-family tx-discount">ส่วนลดกลุ่ม 10%</span>
              <Button
                class="btn btn-s-xs pull-right"
                @click.native="createFamilyQuotation('FM004')"
              >
                ขอใบเสนอราคา
              </Button>
              <h6 class="m-l-xs m-t-xs">มีได้ทั้งหมด 6 กรณี</h6>
              <hr class="hr-1" />
            </div>
            <div class="col-md-12 col-xs-12 card-body-family">
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" />
                <i class="fas fa-user" /> 2 บิดา+มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" /> 2 เด็กโต
              </span>

              <hr class="hr-dot clear" />

              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" />
                <i class="fas fa-user" /> 2 บิดา+มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-baby icon-color2" />
                <i class="fas fa-baby icon-color2" /> 2 เด็กเล็ก
              </span>

              <hr class="hr-dot clear" />

              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" />
                <i class="fas fa-user" /> 2 บิดา+มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-child icon-color1" /> 1 เด็กโต
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-baby icon-color2" /> 1 เด็กเล็ก
              </span>

              <hr class="hr-dot clear" />

              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" /> 1 บิดา/มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" /> 3 เด็กโต
              </span>

              <hr class="hr-dot clear" />

              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" /> 1 บิดา/มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" /> 2 เด็กโต
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-baby icon-color2" /> 1 เด็กเล็ก
              </span>

              <hr class="hr-dot clear" />

              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" /> 1 บิดา/มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-child icon-color1" /> 1 เด็กโต
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-baby icon-color2" />
                <i class="fas fa-baby icon-color2" /> 2 เด็กเล็ก
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-sm-12 m-t">
        <div class="col-sm-12 family-bg-white">
          <div class="col-lg-5 col-md-3 col-xs-5">
            <img src="../assets/images/family/5-01.png" class="img-card-family img-full" />
          </div>
          <div class="col-lg-7 col-md-9 col-xs-7 no-padd">
            <div class="no-padd-b padd-h-f">
              <span class="head-fammily m-l-xs tx-card-family text-tvi">5 บุคคล</span>
              <span class="head-fammily tx-card-family tx-discount">ส่วนลดกลุ่ม 10%</span>
              <Button
                class="btn btn-s-xs pull-right"
                @click.native="createFamilyQuotation('FM005')"
              >
                ขอใบเสนอราคา
              </Button>
              <h6 class="m-l-xs m-t-xs">มีได้ทั้งหมด 6 กรณี</h6>
              <hr class="hr-1" />
            </div>
            <div class="col-md-12 col-xs-12 card-body-family">
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" />
                <i class="fas fa-user" /> 2 บิดา+มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" /> 3 เด็กโต
              </span>

              <hr class="hr-dot clear" />

              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" />
                <i class="fas fa-user" /> 2 บิดา+มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" /> 2 เด็กโต
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-baby icon-color2" /> 1 เด็กเล็ก
              </span>

              <hr class="hr-dot clear" />

              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" />
                <i class="fas fa-user" /> 2 บิดา+มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-child icon-color1" /> 1 เด็กโต
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-baby icon-color2" />
                <i class="fas fa-baby icon-color2" /> 2 เด็กเล็ก
              </span>

              <hr class="hr-dot clear" />

              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" /> 1 บิดา/มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" /> 4 เด็กโต
              </span>

              <hr class="hr-dot clear" />

              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" /> 1 บิดา/มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" /> 3 เด็กโต
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-baby icon-color2" /> 1 เด็กเล็ก
              </span>

              <hr class="hr-dot clear" />

              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" /> 1 บิดา/มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" /> 2 เด็กโต
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-baby icon-color2" />
                <i class="fas fa-baby icon-color2" /> 2 เด็กเล็ก
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-sm-12 m-t">
        <div class="col-sm-12 family-bg-white">
          <div class="col-lg-5 col-md-3 col-xs-5">
            <img src="../assets/images/family/6-01.png" class="img-card-family img-full" />
          </div>
          <div class="col-lg-7 col-md-9 col-xs-7 no-padd">
            <div class="no-padd-b padd-h-f">
              <span class="head-fammily m-l-xs tx-card-family text-tvi">6 บุคคล</span>
              <span class="head-fammily tx-card-family tx-discount">ส่วนลดกลุ่ม 10%</span>
              <Button
                class="btn btn-s-xs pull-right"
                @click.native="createFamilyQuotation('FM006')"
              >
                ขอใบเสนอราคา
              </Button>
              <h6 class="m-l-xs m-t-xs">มีได้ทั้งหมด 6 กรณี</h6>
              <hr class="hr-1" />
            </div>
            <div class="col-md-12 col-xs-12 card-body-family">
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" />
                <i class="fas fa-user" /> 2 บิดา+มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" /> 4 เด็กโต
              </span>

              <hr class="hr-dot clear" />

              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" />
                <i class="fas fa-user" /> 2 บิดา+มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" /> 3 เด็กโต
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-baby icon-color2" /> 1 เด็กเล็ก
              </span>

              <hr class="hr-dot clear" />

              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" />
                <i class="fas fa-user" /> 2 บิดา+มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" /> 2 เด็กโต
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-baby icon-color2" />
                <i class="fas fa-baby icon-color2" /> 2 เด็กเล็ก
              </span>

              <hr class="hr-dot clear" />

              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" /> 1 บิดา/มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" /> 5 เด็กโต
              </span>

              <hr class="hr-dot clear" />

              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" /> 1 บิดา/มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" /> 4 เด็กโต
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-baby icon-color2" /> 1 เด็กเล็ก
              </span>

              <hr class="hr-dot clear" />

              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-user" /> 1 บิดา/มารดา
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" />
                <i class="fas fa-child icon-color1" /> 3 เด็กโต
              </span>
              <span class="col-md-4 col-xs-4 no-padd-m">
                <i class="fas fa-baby icon-color2" />
                <i class="fas fa-baby icon-color2" /> 2 เด็กเล็ก
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 clear" style="margin-top:25px;">
        <h5 class="font-bold m-t text-tvi">สำหรับเงื่อนไขส่วนลดการซื้อประกันภัยกลุ่มมี ดังนี้</h5>
        <h6 class="font-bold m-t-xs">ส่วนลด5% สำหรับ</h6>
        <ul class="h6 m-l-md text-dark" style="line-height:18px;">
          <li>ผู้ใหญ่ (บิดาหรือมารดา ท่านใดท่านหนึ่ง) ทำพร้อมกับบุตรต่ำกว่า 16 ปี 1-2 คน หรือ</li>
          <li>คู่สมรส ทำพร้อมกัน หรือ คู่ชีวิต ทำพร้อมกัน</li>
        </ul>
        <h6 class="font-bold">
          ส่วนลด10% สำหรับ (เบี้ยผู้ใหญ่ มากกว่า 2 คน และ เด็กเล็ก ไม่เกิน 2 คน)
        </h6>
        <ul class="h6 m-l-md text-dark" style="line-height:18px;">
          <li>ผู้ใหญ่ (บิดา และ มารดา ทั้งสองท่าน) ทำพร้อมกับบุตรต่ำกว่า 16 ปี 1-2 คน หรือ</li>
          <li>
            ผู้ใหญ่ (บิดาหรือมารดา และ บุตร อายุเกิน 16 ปี) ทำพร้อมกับ บุตรต่ำกว่า 16 ปี 1-2 คน หรือ
          </li>
          <li>ผู้ใหญ่ (บิดา และ มารดา และ บุตร อายุเกิน 16 ปี) ทำพร้อมกัน หรือ</li>
          <li>ผู้ใหญ่ (คู่ชีวิต ทั้งสองท่าน) ทำพร้อมกับ บุตร</li>
        </ul>
        <h6 class="font-bold">เงื่อนไขทั่วไป</h6>
        <ul class="h6 m-l-md text-dark" style="line-height:18px;">
          <li>ผู้เอาประกันภัยอายุตั้งแต่ 1 เดือน - 70ปี</li>
          <li>ผู้เอาประกันภัย สุขภาพร่างกายสมบูรณ์ แข็งแรง ไม่มีส่วนใดส่วนหนึ่งพิการ</li>
          <li>
            ผู้เอาประกันภัยสามารถซื้อสูงสุด ไม่เกิน2กรมธรรม์ต่อท่าน (รวมทุกผลิตภัณฑ์สุขภาพที่
            ซื้อกับบมจ. ประกันภัยไทยวิวัฒน์ ที่ขายผ่าน ttb และยังมีผลคุ้มครองอยู่)
          </li>
        </ul>
        <h5 class="text-danger" style="font-weignht:bold;">
          หมายเหตุ : ในกรณีที่จ่ายค่าเบี้ยประกันภัยไม่ครบตามจำนวนสมาชิก ทางบริษัทขอทำการยกเลิก
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Button from '@/components/Button'

export default {
  name: 'TypeFamily',
  components: { Button },
  methods: {
    ...mapActions(['createFamilyQuotation']),
  },
}
</script>
